import auth from "../middleware/auth";

export default [
  {
    path: "/uzgidromet/dashboard",
    name: "uzgidromet-dashboard",
    component: () => import("./../views/uzgidromet/Dashboard.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          i18n: "navmenu.uzgidromet.index",
          title: "Госкомгеология",
          active: true
        },
        {
          i18n: "navmenu.uzgidromet.results",
          title: "Показатели",
          active: true
        }
      ]
    },
    pageTitle: "Front",
    rule: "editor"
  }
];
